import { render, staticRenderFns } from "./EOArchitectureWorkshopCheckout.vue?vue&type=template&id=1bfe5a4a&"
import script from "./EOArchitectureWorkshopCheckout.vue?vue&type=script&lang=js&"
export * from "./EOArchitectureWorkshopCheckout.vue?vue&type=script&lang=js&"
import style0 from "./EOArchitectureWorkshopCheckout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol, BRow, BContainer} from 'bootstrap-vue'
    installComponents(component, {BCol, BRow, BContainer})
    

export default component.exports